import React, { useEffect, useState } from "react";
import RateCanvas from "../Components/RateCanvas";
import { useLocation } from "react-router-dom";
import Api from "../Components/Api";
import { BASE_API_URL } from "../Components/const";
import {
  Box,
  Table,
    TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

const Image = () => {
  const [responseAPI, setResponseAPI] = useState(null);

  const location = useLocation();
  const [filmId, setFilmId] = useState(null);

  useEffect(() => {
    if (filmId) getDataFilmWithID();
  }, []);

  useEffect(() => {
    // Извлечение параметров из URL
    const url = window.location.href;
    const pathname = new URL(url).pathname;
    const id = pathname.split("/").pop();

    // Установка id фильма в состояние
    if (id) {
      setFilmId(id);
      // Здесь вы можете вызвать API или выполнить другое действие с этим id
    }
  }, [location]);

  useEffect(() => {
    if (filmId !== null) {
      getDataFilmWithID(filmId);
      // getDataFilmHistory(filmId);
      // getDataFilmList(1);
      // getDataListChannels();
    }
  }, [filmId]);

  async function getDataFilmWithID(id) {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/movie/${id}`);
      console.log("response ", response);
      setResponseAPI(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }


    return (
  <Box>
          {responseAPI ? (
                      <RateCanvas rates={responseAPI} />
          ) : (
            <Typography>Загрузка данных...</Typography>
          )}
  </Box>


  );
};

export default Image;
